/**
 * Is `value` one of the members of the closed string union `members` names?
 *
 * The same two-line shape — `(list as readonly string[]).includes(value)` behind a type predicate
 * — was written out independently for `VitalsTab.tsx`'s `isVitalType` and
 * `routes/patients/chartAccess.ts`'s `isChartAccessDenialReason` in this diff (and appears again,
 * unrelated to this diff, in several `shared/` modules — `isRole`, `isEncounterStatus`,
 * `isCareTeamRelationship`, and others — which this helper does not touch: those are pre-existing,
 * shipped call sites outside this task's scope, not duplication this diff introduced). Extracted
 * here once it recurred a second time within this diff's own new code, per
 * `claude-kit/rules/invariants.md`'s "Favor the general, reusable solution once a pattern actually
 * recurs".
 */
export function isMemberOf<T extends string>(members: readonly T[], value: string): value is T {
  return (members as readonly string[]).includes(value);
}
